import { useEffect, useState } from 'react';

// navigator.storage.estimate() is the only cross-browser way to know how
// close the app is to its IndexedDB quota (relevant now that photos can sit
// queued on-device while offline). Support is universal on the browsers this
// app targets, but feature-detected anyway since it's an optional API.
const POLL_INTERVAL_MS = 15000;

export function useStorageEstimate() {
    const supported = typeof navigator !== 'undefined' && !!navigator.storage?.estimate;
    const [usageBytes, setUsageBytes] = useState(null);
    const [quotaBytes, setQuotaBytes] = useState(null);

    useEffect(() => {
        if (!supported) return undefined;

        let cancelled = false;
        const refresh = async () => {
            const { usage, quota } = await navigator.storage.estimate();
            if (!cancelled) {
                setUsageBytes(usage);
                setQuotaBytes(quota);
            }
        };

        refresh();
        const timer = setInterval(refresh, POLL_INTERVAL_MS);
        return () => {
            cancelled = true;
            clearInterval(timer);
        };
    }, [supported]);

    return { supported, usageBytes, quotaBytes };
}
